export default {
  /**
   * This util parses the string ActivityJson
   * In certain cases the ActivityJson is stringified twice and so this method validates that the data returned is in
   * JSON format.
   * @param rawValue
   * @returns {*}
   */
  resolve(rawValue) {
    let activityJson = rawValue
    while (typeof activityJson === 'string') {
      activityJson = JSON.parse(activityJson)
    }
    return activityJson
  }
}
